import styles from './PosTech.module.css';
import postech from './../PartnersLogo/positive-tech-mte-belarus.jpeg';

const Positivtechnologies = () => {
   return (
      <div className="container-lg">
         <div className="row justify-content-start m-5">
            <div className="col">
               <header className={styles.header}>
                  <h6>Главная--Партнеры--Positive Technologies</h6>
                  <h1>Positive Technologies</h1>
               </header>
            </div>
         </div>

            <hr />

         <div className="row justify-content-start">

               <div className="col-lg-4 col-sm-12 justify-content-center">
                  <img className={styles.body} src={postech} alt="actlogo" />
               </div>

                <div className="col-lg-8 col-sm-12 ">
                <div>
                  <h4>Positive Technologies — ведущий разработчик решений для информационной безопасности.</h4>
                  <p>Наши технологии и сервисы используют более 2300 организаций по всему миру, в том числе 80% компаний из рейтинга «Эксперт-400». В России Positive Technologies — первая и единственная публичная компания из сферы кибербезопасности на Московской бирже (MOEX: POSI).</p>
                  <p>Уже 20 лет наша основная задача — предотвращать хакерские атаки до того, как они причинят неприемлемый ущерб бизнесу и целым отраслям.</p>
                  <p>Новый класс решений компании — метапродукты — ориентирован на результативный подход к кибербезопасности. Они позволяют останавливать хакеров силами одного человека в автоматическом режиме с измеримым эффектом. Первый метапродукт Positive Technologies — MaxPatrol O2 — автоматически выявляет и предотвращает атаки до того, как будет нанесен неприемлемый для компании ущерб. MaxPatrol O2 заменяет целую команду центра мониторинга кибербезопасности, а чтобы им управлять, достаточно одного человека. Такая система защиты требует от специалистов минимума знаний и усилий.</p>
                  <p>Чтобы продемонстрировать реальность результативного подхода к ИБ, компания проводит киберучения, в том числе на собственной инфраструктуре, и публично тестирует свои продукты. Решения Positive Technologies построены на исследовательском опыте и экспертизе нескольких сотен специалистов по кибербезопасности.</p>
                  <p>Сегодня у компании семь офисов на территории России (в Москве, Санкт-Петербурге, Нижнем Новгороде, Самаре, Новосибирске, Академгородке (Новосибирск) и Томске) и один в Казахстане (Нур-Султан). Команда насчитывает более 1200 сотрудников, в их числе эксперты мирового уровня в вопросах защиты SCADA- и ERP-систем, банков и телекомов, мобильных и веб-приложений.</p>
               </div>
                </div>
         </div>
      </div>
   )
}
export default Positivtechnologies;
